const data = [
  { subject: "Math", own: 6 },
  { subject: "Math", own: 6 },
  { subject: "Math", own: 6 },
  { subject: "Math", own: 6 },
  { subject: "Math", own: 6 },
  { subject: "Math", own: 6 },
  { subject: "Math", own: 6 }
];
const data2 = [
  { subject: "Math", own: 6, peer1: 5 },
  { subject: "Math", own: 6, peer1: 5 },
  { subject: "Math", own: 6, peer1: 5 },
  { subject: "Math", own: 6, peer1: 5 },
  { subject: "Math", own: 6, peer1: 5 },
  { subject: "Math", own: 6, peer1: 5 },
  { subject: "Math", own: 6, peer1: 5 }
];
const data3 = [
  { subject: "Math", own: 6, peer1: 5, peer2: 4 },
  { subject: "Math", own: 6, peer1: 5, peer2: 4 },
  { subject: "Math", own: 6, peer1: 5, peer2: 4 },
  { subject: "Math", own: 6, peer1: 5, peer2: 4 },
  { subject: "Math", own: 6, peer1: 5, peer2: 4 },

  { subject: "Math", own: 6, peer1: 5, peer2: 4 },
  { subject: "Math", own: 6, peer1: 5, peer2: 4 }
];
const data4 = [
  { subject: "Math", own: 6, peer1: 5, peer2: 4, peer3: 3 },
  { subject: "Math", own: 6, peer1: 5, peer2: 4, peer3: 3 },
  { subject: "Math", own: 6, peer1: 5, peer2: 4, peer3: 3 },
  { subject: "Math", own: 6, peer1: 5, peer2: 4, peer3: 3 },

  { subject: "Math", own: 6, peer1: 5, peer2: 4, peer3: 3 },
  { subject: "Math", own: 6, peer1: 5, peer2: 4, peer3: 3 },
  { subject: "Math", own: 6, peer1: 5, peer2: 4, peer3: 3 }
];

export function getData(item) {
  const peer = calculateResponses(item);
  if (peer === 1) {
    return data2;
  }
  if (peer === 2) {
    return data3;
  }
  if (peer === 3) {
    return data4;
  }
  return data;
}

export function calculateResponses(results) {
  if (results.peer3) {
    return 3;
  }
  if (results.peer2) {
    return 2;
  }
  if (results.peer1) {
    return 1;
  }
  return 0;
}



// WEBPACK FOOTER //
// ./src/components/Charts/chartData.js